module.exports = __webpack_public_path__ + "media/images/pattern-clubs.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pattern-clubs.png
// module id = 73
// module chunks = 0